import * as React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Navbar } from './components/Navbar/Navbar';
import { Home } from './components/views/Home/Home';
import { SelectClinic } from './components/views/SelectClinic/SelectClinic';
import { Patient } from './components/views/Patient/Patient';
import 'soprasteria-ui-library';
import './assets/styles/common.scss';
import { PatientsUnlisted } from "./components/views/PatientsUnlisted/PatientsUnlisted";
import { PATIENT, SELECT_CLINIC, UNLISTED_PATIENTS, LISTED_PATIENTS, REFERRAL_SUMMARY, RISK_POT_REPORT_WITH_REGISTERED_PRE_ASSESSMENT, REFERRAL_SEARCH, CHECK_BUDGETS, RISK_POT_REPORT_SEARCH, IMPORTED_XMLS, EMAIL_SETTING, ORTHODONTIC_REFERRAL_SEARCH, ORTHODONTIC_LKGCF_PATIENTS, GENERAL_DENTAL_REFERRAL_SEARCH, ORTHODONTIC_REFERRAL_PROVNINGSKONSULT, INVOICES, INVOICE, ENDED_LISTINGS, PATIENT_TREATMENT_SEARCH, PREVENTION_PROGRAM_INFANTS, RISK_POT_REPORT_PRE_ASSESSMENT_SEARCH, ORTHODONTIC_LKGCF_PATIENT_EXTENSION_SEARCH, ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_CONSULTATION_DENTAL_GROUP, ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_JOINT_CONSULTATION_GROUP, SILENT_RENEW, EMERGENCY_TREATMENT_SEARCH, PATIENTS_REFRAINING_FREE_DENTAL_CARE, ADDITIONAL_ASSIGNMENTS } from "./utils/RouteConstants"
import { PatientsListings } from "./components/views/PatientsListings/PatientsListings";
import { useAuth } from "./App";
import { UserApi } from "./api/UserApi";
import { IUserInfo } from "./models/IUserInfo";
import { UserContext, InitUserInfo } from "./contexts/UserContext";
import { ReferralUnderReviewSummary } from "./components/views/Referral/ReferralSummary/ReferralUnderReviewSummary";
import { RiskPotReportsWithRegisteredPreAssessment } from "./components/views/RiskPotReportsWithRegisteredPreAssessment/RiskPotReportsWithRegisteredPreAssessment";
import { LIB_WEB_BASE_PATH } from "./utils/Config";
import { SortTableProvider } from "soprasteria-ui-library";
import { ReferralSearch } from "./components/views/ReferralSearch/ReferralSearch";
import { CheckBudgets } from "./components/views/CheckBudgets/CheckBudgets";
import { RiskPotReportSearch } from "./components/views/RiskPotReportSearch/RiskPotReportSearch";
import { EmailSetting } from "./components/views/EmailSetting/EmailSetting";
import { OrthodonticReferralSearch } from "./components/views/OrthodonticReferralSearch/OrthodonticReferralSearch";
import { OrthodonticLkgCfPatients } from "./components/views/OrthodonticLkgCfPatients/OrthodonticLkgCfPatients";
import { ImportedXmls } from "./components/views/ImportedXml/ImportedXmls";
import { GeneralDentalReferralSearch } from "./components/views/GeneralDentalReferralSearch/GeneralDentalReferralSearch";
import { OrthodonticReferralProvningskonsultSummary } from "./components/views/OrthodonticReferralProvningskonsult/OrthodonticReferralProvningskonsultSummary";
import { ImportedXmlDetails } from "./components/views/ImportedXmlDetails/ImportedXmlDetails";
import { Invoices } from "./components/views/Invoices/Invoices";
import { Invoice } from "./components/views/Invoice/Invoice";
import { PatientTreatmentSearch } from "./components/views/PatientTreatmentSearch/PatientTreatmentSearch";
import { ListingsEnded } from "./components/views/ListingsEnded/ListingsEnded";
import { PatientsRefrainingFreeDentalCare } from "./components/views/PatientsRefrainingFreeDentalCare/PatientsRefrainingFreeDentalCare";
import { SessionExpiredModal } from "./components/SessionExpiredModal/SessionExpiredModal";
import { PreventionProgramInfants } from "./components/views/PreventionProgramInfants/PreventionProgramInfants";
import { RiskPotReportPreAssessmentSearch } from "./components/views/RiskPotReportPreAssessmentSearch/RiskPotReportPreAssessmentSearch";
import { OrthodonticLkgCfPatientExtensionSearch } from "./components/views/OrthodonticLkgCfPatientExtensionSearch/OrthodonticLkgCfPatientExtensionSearch";
import { OrthodonticReferralAdvancedConsultationNeedsForConsultationDentalGroup } from "./components/views/OrthodonticReferralAdvancedConsultationNeedsForConsultationDentalGroup/OrthodonticReferralAdvancedConsultationNeedsForConsultationDentalGroup";
import { OrthodonticReferralAdvancedConsultationNeedsForJointConsultationGroup } from "./components/views/OrthodonticReferralAdvancedConsultationNeedsForJointConsultationGroup/OrthodonticReferralAdvancedConsultationNeedsForJointConsultationGroup";
import { EmergencyTreatmentSearch } from "./components/views/EmergencyTreatmentSearch/EmergencyTreatmentSearch";
import { AdditionalAssignments } from "./components/views/AdditionalAssignments/AdditionalAssignments";


export const AuthenticatedApp: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const userApi = new UserApi(auth);
    const [userInfo, setUserInfo] = React.useState<IUserInfo>();

    React.useEffect(() => {
        if (auth.isAuthenticated) {
            userApi.getUser(2, (userInfo: IUserInfo) => {
                setUserInfo(userInfo);
                auth.setUserRolesGroup(userInfo.rolesGroupId);
            });
        } else {
            document.getElementById("open-session-expired-modal")?.click();
        }
    }, [, auth.userRolesGroup, auth.isAuthenticated])

    return (
        <UserContext.Provider value={userInfo ? userInfo : InitUserInfo}>
            <BrowserRouter basename={LIB_WEB_BASE_PATH}>
                <Navbar />
                {auth.isAuthenticated ?
                    <Switch>
                        <Route exact path="/">
                            <Home />
                        </Route>
                        <Route exact path={`/${SELECT_CLINIC}`}>
                            <SelectClinic />
                        </Route>
                        <Route path={`/${PATIENT}/:patientGuidId`}>
                            <Patient />
                        </Route>
                        <Route exact path={`/${UNLISTED_PATIENTS}`}>
                            <SortTableProvider>
                                <PatientsUnlisted />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${ADDITIONAL_ASSIGNMENTS}`}>
                            <AdditionalAssignments />
                        </Route>
                        <Route exact path={`/${LISTED_PATIENTS}`}>
                            <SortTableProvider>
                                <PatientsListings />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${ENDED_LISTINGS}`}>
                            <SortTableProvider>
                                <ListingsEnded />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${PATIENTS_REFRAINING_FREE_DENTAL_CARE}`}>
                            <PatientsRefrainingFreeDentalCare />
                        </Route>
                        <Route exact path={`/${REFERRAL_SUMMARY}/:page`}>
                            <ReferralUnderReviewSummary />
                        </Route>
                        <Route exact path={`/${RISK_POT_REPORT_WITH_REGISTERED_PRE_ASSESSMENT}`}>
                            <SortTableProvider>
                                <RiskPotReportsWithRegisteredPreAssessment />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${REFERRAL_SEARCH}`}>
                            <SortTableProvider>
                                <ReferralSearch />
                            </SortTableProvider >
                        </Route>
                        <Route exact path={`/${CHECK_BUDGETS}`}>
                            <CheckBudgets />
                        </Route>
                        <Route exact path={`/${RISK_POT_REPORT_SEARCH}`}>
                            <SortTableProvider>
                                <RiskPotReportSearch />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${IMPORTED_XMLS}`}>
                            <ImportedXmls />
                        </Route>
                        <Route path={`/${IMPORTED_XMLS}/:importedXmlId?/:careProviderId?`}>
                            <ImportedXmlDetails />
                        </Route>
                        <Route exact path={`/${EMAIL_SETTING}`}>
                            <EmailSetting />
                        </Route>
                        <Route exact path={`/${ORTHODONTIC_REFERRAL_SEARCH}`}>
                            <SortTableProvider>
                                <OrthodonticReferralSearch />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${ORTHODONTIC_LKGCF_PATIENTS}`}>
                            <OrthodonticLkgCfPatients />
                        </Route>
                        <Route exact path={`/${GENERAL_DENTAL_REFERRAL_SEARCH}`}>
                            <SortTableProvider>
                                <GeneralDentalReferralSearch />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${ORTHODONTIC_REFERRAL_PROVNINGSKONSULT}`}>
                            <OrthodonticReferralProvningskonsultSummary />
                        </Route>
                        <Route exact path={`/${INVOICES}`}>
                            <SortTableProvider>
                                <Invoices />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${INVOICE}/:invoiceId`}>
                            <Invoice />
                        </Route>
                        <Route exact path={`/${PATIENT_TREATMENT_SEARCH}`}>
                            <SortTableProvider>
                                <PatientTreatmentSearch />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${PREVENTION_PROGRAM_INFANTS}`}>
                            <PreventionProgramInfants />
                        </Route>
                        <Route exact path={`/${RISK_POT_REPORT_PRE_ASSESSMENT_SEARCH}`}>
                            <SortTableProvider>
                                <RiskPotReportPreAssessmentSearch />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${ORTHODONTIC_LKGCF_PATIENT_EXTENSION_SEARCH}`}>
                            <SortTableProvider>
                                <OrthodonticLkgCfPatientExtensionSearch />
                            </SortTableProvider>
                        </Route>
                        <Route exact path={`/${ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_CONSULTATION_DENTAL_GROUP}`}>
                            <OrthodonticReferralAdvancedConsultationNeedsForConsultationDentalGroup />
                        </Route>
                        <Route exact path={`/${ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_JOINT_CONSULTATION_GROUP}`}>
                            <OrthodonticReferralAdvancedConsultationNeedsForJointConsultationGroup />
                        </Route>
                        <Route exact path={`/${EMERGENCY_TREATMENT_SEARCH}`}>
                            <SortTableProvider>
                                <EmergencyTreatmentSearch />
                            </SortTableProvider>
                        </Route>
                    </Switch>
                    :
                    <>
                        <input type="hidden" data-toggle="modal" id="open-session-expired-modal" data-target="#session-expired-modal" />
                        <SessionExpiredModal />
                    </>}

            </BrowserRouter>
        </UserContext.Provider>
    );
}